import * as Jobs from './Utils/jobs';

const merged = {
  ...Jobs
}

export default merged;